module.exports = ".disableLayout {\n  padding: 12px; }\n\n/*# sourceMappingURL=app.component.css.map */\n\n.form-control[disabled]{\n  background-color: #54473A;\n  opacity: 0.7;\n}\n\n.intl-tel-input{\n  width: 100%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main